<template>
    <div class="amazon_edit" style="width: 90%">
        <Breadcrumb></Breadcrumb>
        <div style="text-align: right;margin: auto;;padding-top: 10px;">
            <el-button size="small">一键翻译</el-button>
            <el-button size="small" type="primary"  @click="release">更新到Amazon</el-button>
        </div>
        <div id="main">
            <el-form :model="firstForm" :rules="rules" ref="firstForm" label-width="150px">
                <div class="t_plane self_el_item_form">
                    <div class="pl_til">店铺信息</div>
                    <div class="pl_content">
                        <el-form-item label="店铺账号:" prop="shopAccount">
                            <el-select clearable  v-model="firstForm.shopAccount" size="small" style="width:50%">
                                <el-option
                                        v-for="(item,index) in dpList"
                                        :key="index"
                                        :label="item.shopName"
                                        :value="item.shopId">{{item.shopName}}({{dictData['amazon_site'][item.amazonSite]}})
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="站点选择:" prop="aSite">
                            <el-select clearable  v-model="firstForm.aSite" size="small" style="width:50%">
                                <el-option
                                        v-for="(item,index) in dpzdxzList"
                                        :key="index"
                                        :label="item.aSite"
                                        :value="item.aSite">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="产品分类:" prop="platTypeName">
                            <el-input v-model="firstForm.platTypeName" placeholder="请选择内容" style="width: 300px" size="small" :disabled="true"></el-input>
                            <el-button type="primary" style="margin-left: 15px" size="small" @click="getPlatTypeTree" >选择分类</el-button>
                            <el-row style="color: red">
                                <span>{{firstForm.platTypeName}}</span>
                            </el-row>
                        </el-form-item>
                        <el-form-item label="分类类型:" v-if="classTypeList.length > 0" prop="classType">
                            <el-select clearable  v-model="firstForm.classType" size="small" style="width:50%"  placeholder="请选择分类类型">
                                <el-option
                                        v-for="item in classTypeList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="产品类型:" prop="catIdType" v-if="catIdTypeList.length > 0">
                            <el-select clearable  v-model="firstForm.catIdType" size="small" style="width:50%"  placeholder="请选择产品类型">
                                <el-option
                                        v-for="item in catIdTypeList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="售卖形式:" prop="sellForm">
                            <el-radio-group class="radio-group-two" v-model="firstForm.sellForm" @change="sellFormClick">
                                <el-radio label="01">单品</el-radio>
                                <el-radio label="02">多属性</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="品牌入驻商:" prop="brands">
                            <el-radio-group class="radio-group-two" v-model="firstForm.brands" >
                                <el-radio label="0">是</el-radio>
                                <el-radio label="1">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                </div>
                <!--xx信息-->
                <div class="t_plane self_el_item_form">
                    <div class="pl_til">1号定制信息(注:下列信息,仅在此xxx生效)</div>
                    <div class="pl_content">
                        <el-form-item label="1号定制分类">
                            <TreeSelect :props="treeSelect" :options="dataList"  v-model="firstForm.typeNo" ref="childSelTree"
                                        style="width: 50%;margin-right: 10px" @getValue="getTreeNodeId"></TreeSelect>
                        </el-form-item>
                        <el-form-item label="来源URL">
                            <template v-for="(item,index) in firstForm.urls" >
                                <el-input :key="'url_4_' + index" size="small" v-model="item.url" style="width:50%;margin:0 5px 5px 0;">
                                    <template slot="prepend" style="width: 20px;">{{index +1}}</template>
                                    <el-button slot="append" @click="goUrl(item.url)">访问</el-button>
                                </el-input>
                                <a :key="'a_1' +index" class="url_a" @click="addUrl"><i class="el-icon-plus" v-show="index == 0 && firstForm.urls.length < 5"></i></a>
                                <a :key="'a_2' +index" class="url_a" @click="deleteUrl(index)"><i class="el-icon-minus" v-if="index > 0"></i></a>
                            </template>
                        </el-form-item>
                    </div>
                </div>
                <div class="t_plane self_el_item_form">
                    <div class="pl_til">产品信息</div>
                    <div class="pl_content">
                        <el-form-item label="ParentSKU" prop="parentsku">
                            <el-input type="text" maxlength="40" show-word-limit size="small" v-model="firstForm.parentsku" style="width:50%"></el-input>
                        </el-form-item>
                        <el-form-item prop="productTitle" label="产品标题">
                            <el-input size="small" v-model="firstForm.productTitle" style="width:50%"></el-input>
                        </el-form-item>
                        <el-form-item prop="UPC" label="UPC" v-if="firstForm.sellForm=='01'">
                            <el-input @input="handleUPCValue" size="small" v-model="firstForm.UPC" style="width:50%" maxlength="14" ></el-input>
                        </el-form-item>
                        <el-form-item label="品牌" prop="brand">
                            <el-input type="text" maxlength="50" show-word-limit size="small" v-model="firstForm.brand" style="width:50%"></el-input>
                        </el-form-item>
                        <el-form-item label="制造商" prop="manufacturer">
                            <el-input type="text" maxlength="40" show-word-limit size="small" v-model="firstForm.manufacturer" style="width:50%"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="t_plane self_el_item_form">
                    <div class="pl_til">属性信息(请勾选要选择的信息)</div>
                    <div class="pl_content">
                        <div class="pl_content">
                            <div class="attr_dyna">
                                <el-form-item v-for="(item,index) in platProList" :label="item.engAttrName+'('+item.attrName+')'">
                                    <el-row>
                                        <el-col :span="15">
                                    <!--输入框-->
                                    <el-input v-if="item.dataType=='01'" size="mini" v-model="item.selectValue" ></el-input>
                                    <!--文本域-->
                                    <el-input
                                            type="textarea"
                                            placeholder="请输入内容"
                                            v-model="item.selectValue"
                                            maxlength="30"
                                            show-word-limit
                                            :rows="3"
                                            v-else-if="item.dataType=='04'"
                                            size="mini">
                                    </el-input>
                                    <!--单选-->
                                    <el-select clearable  v-model="item.selectValue" placeholder="请选择" size="mini" v-else-if="item.dataType=='02'" style="width: 100%">
                                        <el-option
                                                v-for="(item_2,index_2) in item.sAttrProvals"
                                                :label="item_2.engValName+'('+item_2.valName+')'"
                                                :value="item_2.valId"
                                                >
                                        </el-option>
                                    </el-select>
                                    <!--多选-->
                                    <el-select clearable  v-model="item.selectValue" multiple placeholder="请选择" size="mini"  v-else-if="item.dataType=='03'" style="width: 100%">
                                        <el-option
                                                v-for="(item_2,index_2) in item.sAttrProvals"
                                                :label="item_2.engValName+'('+item_2.valName+')'"
                                                :value="item_2.valId"
                                               >
                                        </el-option>
                                    </el-select>
                                    <!--枚举多选-->
                                    <div v-else-if="item.dataType=='06'" class="attrVal">
                                        <!--<el-checkbox :indeterminate="isIndeterminate" v-model="item.selectValue" @change="checkde">全选</el-checkbox>-->
                                        <!--<div style="margin: 15px 0;"></div>-->
                                        <el-checkbox-group v-model="item.selectValue" @change="checkedManyVal">
                                            <el-checkbox v-for="(item_2,index_2) in item.sAttrProvals" :label="item_2.valId" :key="item_2.valId">{{item_2.engValName+'('+item_2.valName+')'}}</el-checkbox>
                                        </el-checkbox-group>
                                    </div>

                                    <!--枚举单选-->
                                    <div v-else-if="item.dataType=='05'" class="attrVal">
                                        <el-radio v-model="item.selectValue" :label="item_2.valId" v-for="(item_2,index_2) in item.sAttrProvals">{{item_2.engValName+'('+item_2.valName+')'}}</el-radio>
                                    </div>
                                    <!--时间-->
                                    <el-date-picker
                                            v-model="item.selectValue"
                                            type="datetime"
                                            placeholder="选择日期时间"
                                            v-else-if="item.dataType=='07'"
                                    >
                                    </el-date-picker>
                                        </el-col>
                                        <el-col :span="9">
                                            <span  style="font-size: 12px;margin-left: 15px">{{'('+item.importType+')'}}</span>
                                        </el-col>
                                    </el-row>
                                </el-form-item>
                            </div>

                        </div>
                    </div>
                </div>
                <!--图片信息-->
                <div class="t_plane self_el_item_form">
                    <div class="pl_til">图片信息</div>
                    <div class="pl_content">
                        <div style="position: relative">
                            <el-upload style="padding-left: 100px" multiple :file-list="fileList" action="#" :before-upload="beforeUpload" :http-request="imgInfoUpload" :show-file-list="false">
                                <el-button size="small" type="primary">点击上传</el-button>

                                <div slot="tip" class="el-upload__tip">
                                    <div style="display: flex;">
                                        <div style="width:40px;text-align: center;background-color: #009999;margin-right: 10px;color: white"><span>说明</span></div>
                                        <div>
                                            <span>点击图片拖动，即可调整图片顺序! [图片最多选9张，当前已选择 <span style="color: red">{{imgCheckList.length}}</span> 张]</span>
                                        </div>
                                    </div>
                                    <el-checkbox-group v-model="imgCheckList" :max="9">
                                        <draggable :animation='200' :list="firstForm.pics" @start="popoverDisabled = true" @end="popoverDisabled = false">
                                            <transition-group style="display: flow-root">
                                                <li class="prop-list"  v-for="(item,index) in firstForm.pics" :key="index" >
                                                    <div style="display: flex;justify-content: space-between;margin: 0 10px">
                                                        <el-checkbox :label="item" @change="val => selectPic(val,item)" >选择</el-checkbox>
                                                        <el-button style="padding: 0 !important;" size="mini" class="mini-btn" type="text" @click="setMainPic(index)">
                                                            <span v-if="item.isMain=='1'" style="color: red">主图</span>
                                                            <span v-else>设为主图</span>
                                                        </el-button>
                                                    </div>
                                                    <div style="margin: 0 10px 15px;border: 1px solid #EBEEF5">
                                                        <el-popover placement="right" :disabled="popoverDisabled" :ref="popoverRef + index" :close-delay="closeDelay" width="300" trigger="click" :enterable="enterable">
                                                            <div style="width: 300px;height: 300px;display: flex;justify-content: center;align-items: center">
                                                                <img :src="item.picUrl" :class="parseInt(item.width) > parseInt(item.height) ?'use-width':'use-height'"/>
                                                            </div>
                                                            <div slot="reference" style="width: 120px;" class="amazon_edit_img">
                                                                <div style="width: 120px;height: 120px;display: flex;justify-content: center;align-items: center">
                                                                    <el-image :src="item.picUrl" style="width: 100%;height: 100%" fit="contain" @load="imgOnload(item)">
                                                                        <div slot="placeholder" class="image-slot">
                                                                            加载中<span class="dot">...</span>
                                                                        </div>
                                                                    </el-image>
                                                                </div>
                                                            </div>
                                                        </el-popover>
                                                        <div style="text-align: center;font-size: 13px;background-color: #EBEEF5">
                                                            <span v-text="item.width"></span> X <span v-text="item.height"></span>
                                                        </div>
                                                        <div style="display: flex;justify-content: space-between">
                                                            <el-button style="padding: 0 !important;" size="mini" class="mini-btn" type="text" @click="editImg(index)">在线美图</el-button>
                                                            <el-button style="padding: 0 !important;" size="mini" class="mini-btn" type="text" @click="removeImg(index)">移除</el-button>
                                                        </div>
                                                    </div>
                                                </li>
                                            </transition-group>
                                        </draggable>
                                    </el-checkbox-group>
                                </div>
                            </el-upload>
                            <div style="position: absolute;right: 10px;top: 10px;color: #409eff;font-size: 13px">
                                <el-button type="text" size="small" ><svg-icon icon-class="cut"/> 改变图片大小</el-button>
                                <el-divider direction="vertical"></el-divider>
                                <el-button type="text" size="small" @click="downloadAllPic"><svg-icon icon-class="download1"/> 导出全部图片</el-button>
                                <el-divider direction="vertical"></el-divider>
                                <el-button type="text" size="small" @click="cleanAllPic"><svg-icon icon-class="clean"/> 清空全部图片</el-button>
                            </div>
                        </div>
                    </div>
                </div>
<!--变种信息-->
                <div class="t_plane self_el_item_form">
                    <div class="pl_til">变种信息</div>
                    <div class="pl_content" v-if="firstForm.sellForm=='02'">
                        <!--<el-form-item label="变种主题">-->
                            <!--<el-select clearable  size="small" v-model="selectBzzt" placeholder="请选择：" @change="bzztChange">-->
                                <!--<el-option v-for="item in platAttrSelectData" :label="item.attrName" :value="item.attrId"></el-option>-->
                            <!--</el-select>-->
                        <!--</el-form-item>-->
                        <el-form-item>
                            <template v-for="(attr,index_1) in platAttrSelectData">
                                <div style="margin-top: 10px" class="sku-attr">
                                    <span style="font-size: 13px;">{{attr.attrName}}:</span><br/>
                                    <div>
                                        <el-checkbox-group v-model="attr.checkList">
                                            <el-checkbox  @change="attrValChecked($event,item,attr)" v-for="(item,index_2) in attr.attrValList" :label="item.name" >
                                                <div v-if="!item.isEdit" >
                                                    <span>{{item.name}}</span>
                                                    <a class="edit-a" href="javascript:void(0)" @click="editCheckBox(item)"> <i class="el-icon-edit" /></a>
                                                </div>
                                                <div v-if="item.isEdit" class="edit-div">
                                                    <el-input class="edit-input" size="mini" style="width: 150px" v-model.trim="item.backupName" maxlength="20" show-word-limit></el-input>
                                                    <a class="save-a" href="javascript:void(0)" @click="saveEditItem(item,attr)" ><svg-icon icon-class="save" /></a>
                                                    <a class="cancle-a" href="javascript:void(0)" @click="cancleEditItem(item)" ><svg-icon icon-class="cancle" /></a>
                                                </div>
                                            </el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                    <el-input size="small" style="width: 30%" v-model.trim="attr.inputValue" maxlength="20" show-word-limit></el-input>
                                    <el-button size="small" type="primary" style="margin-left: 10px" @click="addSkuArr(attr,attr.inputValue)">添加</el-button>
                                </div>
                            </template>
                        </el-form-item>
                        <div style="margin-top: 20px" class="amazon_create_pro" v-show="bzxx.tableData.length > 0">
                            <div style="margin-top: 2px;width: 100%">
                                <el-form :model="bzxx" ref="bzxx" :rules="bzxxRules">
                                    <el-table border :data="bzxx.tableData" style="width: 100%" class="bz-info-tab">
                                        <el-table-column prop="skuno" align="center" width="160">
                                            <template slot="header" slot-scope="scope">
                                                <el-row>
                                                    <span style="color: red">*</span>SKU<br/>
                                                    <a href="javascript:void(0)" @click="creatSkuName" style="color: #029ef3;text-decoration: none">(一键生成)</a>
                                                </el-row>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-form-item :prop="'tableData.' + scope.$index + '.skuno'" :rules="bzxxRules.skuno">
                                                    <el-input size="mini" v-model.trim="scope.row.skuno"/>
                                                </el-form-item>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                width="100" v-for="(item,index) in bzxx.columnList"
                                                :label="item.attrName"
                                                :prop='"column_"+index+""'>
                                        </el-table-column>
                                        <el-table-column prop="barcode" align="center" width="150">
                                            <template slot="header" slot-scope="scope">
                                                <el-row>
                                                    <el-select clearable  size="mini" v-model="firstForm.barcodeType">
                                                        <el-option value="GTIN">GTIN</el-option>
                                                        <el-option value="EAN">EAN</el-option>
                                                        <el-option value="ISBN">ISBN</el-option>
                                                        <el-option value="GCID">GCID</el-option>
                                                        <el-option value="UPC">UPC</el-option>
                                                        <el-option value="ASIN">ASIN</el-option>
                                                    </el-select>
                                                    <br/><span style="color: red">*</span>
                                                    <a href="javascript:void(0)" @click="updateSkuBarcodeVisible = true" style="color: #029ef3;text-decoration: none">(批量编辑)</a>
                                                </el-row>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-form-item :prop="'tableData.' + scope.$index + '.uCode'" :rules="bzxxRules.uCode">
                                                    <el-input size="mini" v-model.trim="scope.row.uCode" maxlength="14" @input="handleUCodeValue($event,scope.$index)" />
                                                </el-form-item>
                                            </template>
                                        </el-table-column>

                                        <el-table-column prop="colorMap" align="center" width="120">
                                            <template slot="header" slot-scope="scope">
                                                <el-row>
                                                    <span style="color: red">*</span>Color Map<br/>
                                                    <a href="javascript:void(0)" @click="updateSkuColorMapVisible = true" style="color: #029ef3;text-decoration: none">(批量)</a>
                                                </el-row>
                                                <!--<el-row style="color: #029ef3;" >(批量)</el-row>-->
                                            </template>
                                            <template slot-scope="scope">
                                                <el-form-item :prop="'tableData.' + scope.$index + '.colorMap'" :rules="bzxxRules.colorMap">
                                                    <el-select clearable  size="mini" v-model="scope.row.colorMap">
                                                        <el-option label="Maroon" value="Maroon"></el-option>
                                                        <el-option label="Gray" value="Gray"></el-option>
                                                        <el-option label="Aqua" value="Aqua"></el-option>
                                                        <el-option label="Blue" value="Blue"></el-option>
                                                        <el-option label="Fuchsia" value="Fuchsia"></el-option>
                                                        <el-option label="Black" value="Black"></el-option>
                                                        <el-option label="Olive" value="Olive"></el-option>
                                                        <el-option label="Red" value="Red"></el-option>
                                                        <el-option label="Lime" value="Lime"></el-option>
                                                        <el-option label="Silver" value="Silver"></el-option>
                                                        <el-option label="Navy" value="Navy"></el-option>
                                                        <el-option label="White" value="White"></el-option>
                                                        <el-option label="Purple" value="Purple"></el-option>
                                                        <el-option label="Yellow" value="Yellow"></el-option>
                                                        <el-option label="Teal" value="Teal"></el-option>
                                                        <el-option label="Green" value="Green"></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </template>
                                        </el-table-column>

                                        <el-table-column prop="noteType" align="center" width="250">
                                            <template slot="header" slot-scope="scope">
                                                Condition and It's Note<br/>
                                                <a href="javascript:void(0)" @click="updateSkuNoteVisible = true" style="color: #029ef3;text-decoration: none">(修改)</a>
                                            </template>
                                            <template slot-scope="scope">
                                                <div style="display: flex;">
                                                    <el-form-item :prop="'tableData.' + scope.$index + '.condition1'">
                                                        <el-select clearable  size="mini" v-model="scope.row.condition1">
                                                            <el-option label="Collectible - Very Good" value="0">Collectible - Very Good</el-option>
                                                            <el-option label="Used - Good" value="1"></el-option>
                                                            <el-option label="Club" value="2"></el-option>
                                                            <el-option label="club" value="3"></el-option>
                                                            <el-option label="Collectible - Acceptable" value="4"></el-option>
                                                            <el-option label="Collectible - Like New" value="5"></el-option>
                                                            <el-option label="Used - Like New" value="6"></el-option>
                                                            <el-option label="Collectible - Good" value="7"></el-option>
                                                            <el-option label="New" value="8"></el-option>
                                                            <el-option label="Used - Very Good" value="9"></el-option>
                                                            <el-option label="Used - Acceptable" value="10"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                    <el-form-item>
                                                        <el-input size="small" v-model.trim="scope.row.note"></el-input>
                                                    </el-form-item>
                                                </div>
                                            </template>
                                        </el-table-column>

                                        <el-table-column prop="price" align="center" width="130">
                                            <template slot="header" slot-scope="scope">
                                                <span style="color: red">*</span>价格<br/>
                                                <a href="javascript:void(0)" @click="openPriceDialog('价格')" style="color: #029ef3;text-decoration: none">(修改)</a>
                                            </template>
                                            <template slot-scope="scope">
                                                    <el-form-item :prop="'tableData.' + scope.$index + '.price'" :rules="bzxxRules.price">
                                                        <el-input size="mini" onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d{1,9}(\.?\d{0,2})/g);" v-model.trim="scope.row.price"/>
                                                    </el-form-item>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="promotePrice" align="center" width="130">
                                            <template slot="header" slot-scope="scope">
                                                <span>促销价</span><br/>
                                                <a href="javascript:void(0)" @click="openPriceDialog('促销价')" style="color: #029ef3;text-decoration: none">(修改)</a>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-input size="mini" onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d{1,9}(\.?\d{0,2})/g);" v-model.trim="scope.row.promPrice"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="name" align="center" width="300">
                                            <template slot="header" slot-scope="scope">
                                                促销时间<br/>
                                                <a href="javascript:void(0)" @click="updateSkuTimeVisible = true"  style="color: #029ef3;text-decoration: none">(批量)</a>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-row class="amazon_date">
                                                    <el-col :span="12">
                                                        <el-form-item  :prop="'tableData.' + scope.$index + '.startDate'" :rules="scope.row.promPrice != null &&  scope.row.promPrice != '' ?[{ required: true,message: '请填写开始日期', trigger: ['blur']}]:[{ required: false}]">
                                                            <el-date-picker
                                                                    size="small"
                                                                    class="date_socpe"
                                                                    v-model.trim="scope.row.startDate"
                                                                    align="right"
                                                                    type="datetime"
                                                                    placeholder="开始日期"
                                                                    :picker-options="skuTimeOption"
                                                            >
                                                            </el-date-picker>
                                                        </el-form-item>
                                                    </el-col>
                                                    <el-col :span="12">
                                                        <el-form-item  :prop="'tableData.' + scope.$index + '.endDate'" :rules="scope.row.promPrice != null &&  scope.row.promPrice != '' ?[{ required: true,message: '请填写结束日期', trigger: ['blur']}]:[{ required: false}]">
                                                            <el-date-picker
                                                                    size="small"
                                                                    class="date_socpe"
                                                                    v-model.trim="scope.row.endDate"
                                                                    align="right"
                                                                    type="datetime"
                                                                    placeholder="结束日期"
                                                                    :picker-options="tabSkuEndTimeOption"
                                                                    @focus="setCurrentSku(scope.row.startDate)"
                                                                    :disabled="scope.row.startDate == null"></el-date-picker>
                                                        </el-form-item>
                                                    </el-col>
                                                </el-row>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="invent" align="center" width="120">
                                            <template slot="header" slot-scope="scope">
                                                <el-row>
                                                    <span style="color: red">*</span>数量<br/>
                                                    <a href="javascript:void(0)" @click="updateSkuInventVisible = true" style="color: #029ef3;text-decoration: none">(批量)</a>
                                                </el-row>
                                            </template>
                                            <template slot-scope="scope">
                                                <el-form-item :prop="'tableData.' + scope.$index + '.invent'" :rules="bzxxRules.invent">
                                                    <el-input onkeyup="value=value.replace(/[^0-9]/g,'').replace(/^0{2}/g,'')" size="mini" v-model.trim="scope.row.invent"/>
                                                </el-form-item>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="name" align="center" width="100">
                                            <template slot="header" slot-scope="scope">
                                                <el-row>操作</el-row>
                                            </template>
                                            <template slot-scope="scope">
<!--                                                <el-button type="text" size="mini" @click="setAttr(scope.row)">设置</el-button>-->
                                                <el-button type="text" size="mini" @click="moveAttr(scope.row,scope.$index)">移除</el-button>
                                                <br/>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-form>
                            </div>
                        </div>

                        <template v-for="group in bzxx.tableData">
                            <div class="bzsx_list">
                                <div class="bzsx_title">
                                    <div style="font-size: 13px;color: #434649;font-weight: 600;width: 6%">变种属性:</div>
                                    <div style="font-size: 12px;color: #000;display: flex;width: 25%">
                                        <p v-for="(lv,i) in bzxx.columnList" style="margin-left: 15px">
                                            <span>{{lv.attrName}}</span>:<span style="margin-left: 5px">{{group['column_'+i]}}</span>
                                        </p>
                                    </div>
                                    <div style="text-align: right;width: 69%">
                                        <el-popover
                                                placement="bottom-end"
                                                width="160"
                                                trigger="hover"
                                        >
                                            <el-button  size="mini" type="text" @click="appBzxxPic(group)">所有变种</el-button>
                                            <el-button slot="reference" size="mini" type="primary">图片应用到<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                                        </el-popover>
                                    </div>
                                </div>
                                <div class="bzsx_contend">
                                    <el-row style="display: flex;margin: 10px">
                                        <div style="width:240px;height: 240px;background-color: #f9f9f9;margin-left: 10px;border: 1px solid #ccc">
                                            <div style="display: flex;align-items: center;height: 60px;padding-left: 10px">
                                                <span style="font-size: 13px;font-weight: 600">主图：</span>
                                                <el-upload v-if="group.mainFile.length==0"  action="#" :before-upload="beforeUpload" :http-request="data => attrMainImgUpload(data,group.mainFile,1,0)" :show-file-list="false">
                                                    <el-button size="small" type="info">点击上传</el-button>
                                                </el-upload>
                                            </div>
                                            <div style="display: flex;justify-content: center;align-items: center">
                                                <div v-if="group.mainFile.length > 0" style="margin: 0 10px 15px;border: 1px solid #EBEEF5;width: 120px;">
                                                    <div class="img-out-border">
                                                        <div style="width: 120px;height: 120px;display: flex;justify-content: center;align-items: center;position: relative">
                                                            <img :src="group.mainFile[0].picUrl" :class="parseInt(group.mainFile[0].width) > parseInt(group.mainFile[0].height) ?'use-width':'use-height'"/>
                                                        </div>
                                                    </div>
                                                    <div style="text-align: center;font-size: 13px;background-color: #EBEEF5">
                                                        <span v-text="group.mainFile[0].width"></span> X <span v-text="group.mainFile[0].height"></span>
                                                    </div>
                                                    <div style="display: flex;justify-content: space-between">
                                                        <el-button style="padding: 0 !important;" size="mini" class="mini-btn" type="text" @click="editImg(group)">在线美图</el-button>
                                                        <el-button style="padding: 0 !important;" size="mini" class="mini-btn" type="text" @click="group.mainFile = []">移除</el-button>
                                                    </div>
                                                </div>
                                                <div v-else style="text-align: center">
                                                    <img src="../../../assets/images/kong.png" style="width: 120px;height: 120px"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div style="width:240px;height: 240px;background-color: #f9f9f9;margin-left: 10px;border: 1px solid #ccc">
                                            <div style="display: flex;align-items: center;height: 60px;padding-left: 10px">
                                                <span style="font-size: 13px;font-weight: 600">Swatch Image：</span>
                                                <el-upload v-if="group.swatchFile.length==0" action="#" :before-upload="beforeUpload" :http-request="data => attrMainImgUpload(data,group.swatchFile,0,1)" :show-file-list="false">
                                                    <el-button size="small" type="info">点击上传</el-button>
                                                </el-upload>
                                            </div>
                                            <div style="display: flex;justify-content: center;align-items: center">
                                                <div v-if="group.swatchFile.length > 0" style="margin: 0 10px 15px;border: 1px solid #EBEEF5;width: 120px;">
                                                    <div class="img-out-border">
                                                        <div style="width: 120px;height: 120px;display: flex;justify-content: center;align-items: center;position: relative">
                                                            <img :src="group.swatchFile[0].picUrl" :class="parseInt(group.swatchFile[0].width) > parseInt(group.swatchFile[0].height) ?'use-width':'use-height'"/>
                                                        </div>
                                                    </div>
                                                    <div style="text-align: center;font-size: 13px;background-color: #EBEEF5">
                                                        <span v-text="group.swatchFile[0].width"></span> X <span v-text="group.swatchFile[0].height"></span>
                                                    </div>
                                                    <div style="display: flex;justify-content: space-between">
                                                        <el-button style="padding: 0 !important;" size="mini" class="mini-btn" type="text" @click="editImg(group)">在线美图</el-button>
                                                        <el-button style="padding: 0 !important;" size="mini" class="mini-btn" type="text" @click="group.swatchFile = []">移除</el-button>
                                                    </div>
                                                </div>
                                                <div v-else style="text-align: center">
                                                    <img src="../../../assets/images/kong.png" style="width: 120px;height: 120px"/>
                                                </div>
                                            </div>
                                        </div>
                                    </el-row>
                                    <el-row style="margin: 10px;">
                                        <div style="min-height: 240px;margin-left: 10px;background-color: #f9f9f9;border: 1px solid #ccc">
                                            <div style="display: flex;align-items: center;height: 60px;padding-left: 10px">
                                                <span style="font-size: 13px;font-weight: 600">附图：</span>
                                                <el-upload v-if="group.otherFile.length<8" :limit="8" multiple action="#" :before-upload=" file => skuImgBeforeUpload" :on-exceed="skuImgExceed" :http-request="data => attrMainImgUpload(data,group.otherFile,0,0)" :show-file-list="false">
                                                    <el-button size="small" type="info">点击上传</el-button>
                                                </el-upload>
                                                <span style="font-size: 13px;margin-left: 10px">[{{group.otherFile.length}}/8] 图片</span>
                                            </div>
                                            <div style="display: flex;align-items: center">
                                                <div v-if="group.otherFile.length > 0" style="display: flow-root;width: 100%">
                                                    <div v-for="(item,index) in group.otherFile" style="border: 1px solid #EBEEF5;margin:5px;width: 120px;float: left">
                                                        <div class="img-out-border">
                                                            <div style="width: 120px;height: 120px;display: flex;justify-content: center;align-items: center;position: relative">
                                                                <img :src="item.picUrl" :class="parseInt(item.width) > parseInt(item.height) ?'use-width':'use-height'"/>
                                                            </div>
                                                        </div>
                                                        <div style="text-align: center;font-size: 13px;background-color: #EBEEF5">
                                                            <span v-text="item.width"></span> X <span v-text="item.height"></span>
                                                        </div>
                                                        <div style="display: flex;justify-content: space-between">
                                                            <el-button style="padding: 0 !important;" size="mini" class="mini-btn" type="text" @click="editImg(group)">在线美图</el-button>
                                                            <el-button style="padding: 0 !important;" size="mini" class="mini-btn" type="text" @click="removeSkuImg(group.otherFile,index)">移除</el-button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else style="text-align: center">
                                                    <img src="../../../assets/images/kong.png" style="width: 120px;height: 120px"/>
                                                </div>
                                            </div>
                                        </div>
                                    </el-row>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="t_plane self_el_item_form">
                    <div class="pl_til">价格与运输</div>
                    <div class="pl_content">
                        <div v-if="firstForm.sellForm=='01'">
                            <el-row>
                                <el-col :span="5" >
                                    <el-form-item label="产品价格:" prop="sellTableData.price" :rules="rules.price">
                                        <el-input @input="handleDecimal('price')" style="width: 100%" size="small"  v-model.trim="firstForm.sellTableData.price" placeholder="0.00"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item label="促销价格:">
                                        <el-input @input="handleDecimal('promPrice')" style="width: 100%" size="small"  v-model.trim="firstForm.sellTableData.promPrice" placeholder="0.00"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item  label="促销日期:" prop="sellTableData.selectDate" :rules="firstForm.sellTableData.promPrice != null &&  firstForm.sellTableData.promPrice != '' ?[{type: 'array', required: true,message: '请选择促销日期', trigger: ['blur']}]:[{type: 'array', required: false}]" >
                                        <el-date-picker
                                                size="small"
                                                v-model.trim="firstForm.sellTableData.selectDate"
                                                type="daterange"
                                                range-separator="~"
                                                start-placeholder="开始日期"
                                                end-placeholder="结束日期"
                                                @change="promDate">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-form-item label="产品数量:" prop="sellTableData.invent" :rules="rules.invent">
                                    <el-input @input="handleNumber('invent')" style="width: 35%" size="small"  v-model.trim="firstForm.sellTableData.invent"></el-input>
                                </el-form-item>
                            </el-row>
                        </div>
                        <el-row>
                            <el-col :span="5" style="text-align: right;font-size: 14px;color: #595a5a">
                                <el-form-item label="其他选项:">
                                </el-form-item>
                            </el-col>
                            <el-col :span="13" style="background-color: rgb(241 241 241);border-radius: 5px;margin-left: 10px;padding-top: 10px">
                                <el-row>
                                    <el-form-item label="处理天数:">
                                        <el-input style="width: 90%" size="small"  v-model="firstForm.dealDays"></el-input>
                                    </el-form-item>
                                </el-row>
                                <el-row>
                                    <el-form-item label="运输模板:">
                                        <el-input style="width: 90%" size="small" v-model="firstForm.transForm"></el-input>
                                    </el-form-item>
                                </el-row>
                                <el-row>
                                    <el-form-item label="礼品包装服务:">
                                        <el-select clearable  v-model="firstForm.isPack" size="small" style="width:90%">
                                            <el-option label="是" value="1"></el-option>
                                            <el-option label="否" value="0"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-row>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <div class="t_plane self_el_item_form">
                    <div class="pl_til">描述信息</div>
                    <div class="pl_content">
                        <el-form-item prop="shotDescription" label="产品描述:">
                            <CKEditor4  v-if="ckVisible" v-model="firstForm.goodsState" :config="editorConfig"  @getCkEditorInstance="getEditor"></CKEditor4>

                        </el-form-item>
                        <el-form-item label="Bullet Point:">
                            <el-input type="textarea" :rows="2" v-model="firstForm.bulletPoint" maxlength="500" show-word-limit style="margin-top: 10px"></el-input>
                            <el-input type="textarea" :rows="2" v-model="firstForm.bulletPoint2" maxlength="500" show-word-limit style="margin-top: 10px"></el-input>
                            <el-input type="textarea" :rows="2" v-model="firstForm.bulletPoint3" maxlength="500" show-word-limit style="margin-top: 10px"></el-input>
                            <el-input type="textarea" :rows="2" v-model="firstForm.bulletPoint4" maxlength="500" show-word-limit style="margin-top: 10px"></el-input>
                            <el-input type="textarea" :rows="2" v-model="firstForm.bulletPoint5" maxlength="500" show-word-limit style="margin-top: 10px"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="t_plane self_el_item_form">
                    <div class="pl_til">关键词信息</div>
                    <div class="pl_content">
                        <el-form-item label="Search Terms:">
                            <el-input type="textarea" v-model="firstForm.searchTerms"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div style="text-align: right;margin: auto;;padding-top: 10px;">
                    <el-button size="small">一键翻译</el-button>
                    <el-button size="small" type="primary"  @click="release">更新到Amazon</el-button>
                </div>
            </el-form>
        </div>

        <ul id="LoutiNav" style="position: fixed;display: block;">
            <li><svg-icon icon-class="right-1"/><span>基本信息</span></li>
            <li><svg-icon icon-class="right-1"/><span>1号定制信息</span></li>
            <li><svg-icon icon-class="right-1"/><span>产品信息</span></li>
            <li><svg-icon icon-class="right-1"/><span>属性信息</span></li>
            <li><svg-icon icon-class="right-1"/><span>图片信息</span></li>
            <li><svg-icon icon-class="right-1"/><span>变种信息</span></li>
            <li><svg-icon icon-class="right-1"/><span>价格与运输</span></li>
            <li><svg-icon icon-class="right-1"/><span>描述信息</span></li>
            <li><svg-icon icon-class="right-1"/><span>关键词信息</span></li>
        </ul>

        <!--Amazon-->
        <el-dialog :close-on-click-modal="false"   title="Amazon平台类目" :visible.sync="shopeeDialogVisible" width="50%" center class="amazon_category_dialog" >
            <el-row class="platRow">
                <div class="platType_1" v-for="(item,index) in platTypeList" >
                    <el-input
                            placeholder="请输入内容"
                            suffix-icon="el-icon-search"
                            v-model.trim="item.inputValue" style="width: 185px" size="mini" @input="searchPlatTypeList(item.pPlatId,item.inputValue,index)">
                    </el-input>
                    <div class="platType_2">
                        <el-row class="rowbg"  @click.native="platTypeTest(item,item_2,index)" v-bind:class='{bg:item_2.platId==item.bgHide}' v-for="(item_2,index_2) in item.data">
                            <el-col :span="20">{{item_2.platName}}</el-col>
                            <el-col :span="4" class="ch" v-show="item_2.childrenTree.length>0"><i class="el-icon-arrow-right"></i></el-col>
                        </el-row>
                    </div>
                </div>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="shopeeDialogVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="shopeeDialogSubmit" size="small">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :close-on-click-modal="false"   title="号码获取" :visible.sync="updateSkuBarcodeVisible" width="500px">
            <div style="margin: 10px 20px 0 20px;">
                <el-row :gutter="20">
                    <el-col :span="4"><el-radio v-model="barcodeModel" label="1"><span style="font-size: 13px">自动获取</span></el-radio></el-col>
                    <el-col :span="20">
                        <div>
                            <el-select clearable  size="small" v-model="autoBarcode" :disabled="barcodeModel != '1'">
                                <el-option label="--请选择--" value=""></el-option>
                            </el-select>
                            <a style="text-decoration: none;color: #409eff;font-size: 12px">+ 管理号码池</a>
                        </div>
                        <div style="margin-top: 10px">
                            <span style="font-size: 13px">剩余可用数量<span style="color: red"> 0 </span>个</span>
                            <el-button type="danger" size="small" :disabled="barcodeModel != '1'">购买UPC</el-button>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-top: 20px">
                    <el-col :span="4"><el-radio v-model="barcodeModel" label="2"><span style="font-size: 13px">自动获取</span></el-radio></el-col>
                    <el-col :span="20">
                        <el-input type="textarea" :rows="4" v-model="updateSkuBarcodeVal" placeholder="请输入内容" :disabled="barcodeModel != '2'"></el-input>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small"  @click="updateSkuBarcodeVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="updateSkuBarcode">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog :close-on-click-modal="false"   title="修改Color Map" :visible.sync="updateSkuColorMapVisible" width="500px">
            <div style="margin: 10px 20px 0 20px;">
                <el-row>
                    <el-col :span="6" style="font-size: 13px;height: 30px;line-height: 30px">
                        Color Map：
                    </el-col>
                    <el-col :span="18">
                        <el-select clearable  size="small" v-model="updateSkuColorMapVal">
                            <el-option label="Maroon" value="Maroon"></el-option>
                            <el-option label="Gray" value="Gray"></el-option>
                            <el-option label="Aqua" value="Aqua"></el-option>
                            <el-option label="Blue" value="Blue"></el-option>
                            <el-option label="Fuchsia" value="Fuchsia"></el-option>
                            <el-option label="Black" value="Black"></el-option>
                            <el-option label="Olive" value="Olive"></el-option>
                            <el-option label="Red" value="Red"></el-option>
                            <el-option label="Lime" value="Lime"></el-option>
                            <el-option label="Silver" value="Silver"></el-option>
                            <el-option label="Navy" value="Navy"></el-option>
                            <el-option label="White" value="White"></el-option>
                            <el-option label="Purple" value="Purple"></el-option>
                            <el-option label="Yellow" value="Yellow"></el-option>
                            <el-option label="Teal" value="Teal"></el-option>
                            <el-option label="Green" value="Green"></el-option>
                        </el-select>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateSkuColorMapVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="updateSkuColorMap" size="small">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :close-on-click-modal="false"   title="修改Condition and It's Note" :visible.sync="updateSkuNoteVisible" width="500px">
            <div style="margin: 10px 20px 0 20px;">
                <el-row>
                    <el-col :span="6" style="font-size: 13px;height: 30px;line-height: 30px">Condition类型：</el-col>
                    <el-col :span="18">
                        <el-select clearable  size="small" v-model="updateSkuNoteTypeVal" style="width: 60%">
                            <el-option label="Collectible - Very Good" value="0">Collectible - Very Good</el-option>
                            <el-option label="Used - Good" value="1"></el-option>
                            <el-option label="Club" value="2"></el-option>
                            <el-option label="club" value="3"></el-option>
                            <el-option label="Collectible - Acceptable" value="4"></el-option>
                            <el-option label="Collectible - Like New" value="5"></el-option>
                            <el-option label="Used - Like New" value="6"></el-option>
                            <el-option label="Collectible - Good" value="7"></el-option>
                            <el-option label="New" value="8"></el-option>
                            <el-option label="Used - Very Good" value="9"></el-option>
                            <el-option label="Used - Acceptable" value="10"></el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 10px">
                    <el-col :span="6" style="font-size: 13px;height: 30px;line-height: 30px">Condition Note：</el-col>
                    <el-col :span="18">
                        <el-input size="small" v-model="updateSkuNoteVal" style="width: 60%"></el-input>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small"  @click="updateSkuNoteVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="updateSkuNote">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :close-on-click-modal="false"   :title="'修改'+priceText" :visible.sync="updateSkuPriceVisible" width="500px">
            <div style="margin: 10px 20px 0 20px;">
                <el-row :gutter="10" style="height: 35px;line-height: 35px;text-align: center">
                    <el-col :span="6" style="font-size: 13px;text-align: right">直接修改价格:</el-col>
                    <el-col :span="10"><el-input size="mini" v-model="updateSkuPriceVal" onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d{1,9}(\.?\d{0,2})/g);"></el-input></el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small"  @click="updateSkuPriceVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="updateSkuPrice">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :close-on-click-modal="false"   title="修改促销时间" :visible.sync="updateSkuTimeVisible" width="500px">
            <div style="margin: 10px 20px 0 20px;">
                <el-date-picker
                        size="small"
                        v-model="updateSkuTimeVal"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="skuTimeOption">
                </el-date-picker>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button size="small"  @click="updateSkuTimeVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="updateSkuPromTime">确 定</el-button>
      </span>
        </el-dialog>
        <!--修改库存弹框-->
        <el-dialog :close-on-click-modal="false"  
                title="修改库存"
                :visible.sync="updateSkuInventVisible"
                width="30%"
                
                @close="cancelPrice">
            <el-row style="margin-top: 15px;margin-left: 30px">
                <el-radio-group v-model="bzxx.inventRadio" @change="inventRadioChange">
                    <el-radio :label="0">
                        <!--正则校验价格-->
                        <el-input ref="inventInput_1" onkeyup="this.value=this.value.replace(/[^\d]/g, '').replace(/^0{2,}/g,'');"  :disabled="bzxx.inventRadioDisabled_1" style="width: 100px" v-model="bzxx.inventInput_1" placeholder="请输入内容" size="mini"></el-input>
                        <span>(直接修改库存量)</span>
                    </el-radio>
                    <div style="margin-bottom: 20px"></div>
                    <el-radio :label="1">
                        <span>按原有库存量 增加</span>
                        <!--正则校验价格-->
                        <el-input onkeyup="this.value=this.value.replace(/[^\d\-]/g, '').replace(/^0{0,}/g,'').replace(/^\-{2}/g,'').match(/^(\-?)\d*/g);"  style="width: 100px;" :disabled="bzxx.inventRadioDisabled_2"  v-model="bzxx.inventInput_2" placeholder="请输入内容" size="mini"></el-input>
                    </el-radio>
                </el-radio-group>
                <el-row>
                    <span>提示:如果减少,可输入负数</span>
                </el-row>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelInvent" size="small">取 消</el-button>
                <el-button type="primary" @click="sumbitInvent" size="small">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script type="text/ecmascript-6">
    import TreeSelect from '@/components/common/treeSelect'
    import Breadcrumb from '@/components/common/Breadcrumb'
    import draggable from "vuedraggable"
    import CKEditor4 from '@/components/common/CKEditor'
    import {loadDataMap} from '@/api/tree/tree'
    import {loadDpmc,loadZdxz,loadSmxs,getTreeList,loadLpfw,getAmazonEdit,uploadImg,saveAmazonEditMsg,releaseProduct} from '@/api/product/amazon'
    import {publicUploadImg,getPicListBypId} from '@/api/product/common';
    import ElCol from "element-ui/packages/col/src/col";
    import {getPlatTypeTree,getPlatTypeName,getPlatTypeNames,listPlatType,getPlatTypeList,treeView,getList,getSplictName} from '@/api/plat/platType';
    import {getListByCatId,getBzztAttrListByCatId} from '@/api/plat/attr';
    import {getListByAttrId,getBzztValListByAttrId} from '@/api/plat/val';
    import {getClassList} from '@/api/plat/class';
    import ElRow from "element-ui/packages/row/src/row";
    import {getCartesianProduct,calcDescartes,toDecimal,randomWord} from '@/utils/jn'
    import {downLoadZipP} from '@/utils/zipdownload'

    export default {
        name: "CreateProduct",
        components: {
            ElRow,
            ElCol,
            TreeSelect,draggable,Breadcrumb,CKEditor4},
        data() {
            var validateNum = (rule, value, callback) => {
                var reg = new RegExp(/^(([0-9]+[\.]?[0-9]+)|[1-9])$/);
                if (!reg.test(value)) {
                    callback(new Error('请输入正确的数值'));
                }
            };
            var checkUPC = (rule, value, callback) => {
                if (value=="" || value==null) {
                    return callback(new Error('UPC不能为空'));
                }else if(value.length < 7){
                    return callback(new Error('UPC必须为8~14位纯数字'));
                }else {
                    //自定义验证必须要执行这个,否则表单的函数执行不了
                    callback();
                }
            };
            return {
                ckVisible:false, //显示编辑副本本
                enterable:false,
                list: [],
                colorList:[],
                zdList: ['印度尼西亚', '菲律宾', '新加坡', '泰国'],
                dpzdxzList:[
                    {
                        aSite:'美国',
                    },
                    {
                        aSite:'中国',
                    },
                    {
                        aSite:'巴基斯坦',
                    },
                ],
                dpsmxsList:[],
                picList:[],
                shopeeOptions:[],
                shopeeDialogVisible:false,
                platTypeList:[],//别的平台分类数据
                copyPlatTypeValue:[],//amazon点击类目时赋值的ID,是个数组,如果一开始有值,这个也要赋值
                platProList:[],//amazon基本属性集合
                platAttrSelectData:[], //变种属性数据集合

                // 保存图片的ID
                picID: [],
                count: 0,
                props: {
                    id: 'id',
                    children: 'children',
                    label: 'typeNme'
                },
                xxForm: {
                    fl: '',
                    urls: [],
                    DefaultUrl: null,
                    typeNo:null,
                    url:[]
                },
                lpfwList:[],
                tableData:[],
                classTypeList:[],//分类类型集合
                catIdTypeList:[],//产品类型集合
                firstForm: {
                    mainPic:null,
                    pubStatus:'05',//05为在线状态
                    typeNo:null,
                    shopAccount: null,//店铺账号
                    aSite:null,//站点
                    catId:null,//产品分类（线上分类）
                    platTypeName:null,//跨境产品分类拼接的名字
                    classType:null,//分类类型
                    catIdType:null,//产品类型
                    sellForm:'01',//售卖形式
                    sellTableData:{
                        price:null,
                        promPrice:null,
                        startDate:null,
                        endDate:null,
                        invent:null,
                        selectDate:[],//选择的促销开始和结束时间
                    },//售卖类型为单品的数据表格
                    brands:'0',//品牌入驻商
                    attrList:[],
                    urls: [],
                    ptType: 7,
                    shopType: null,
                    typeNo:null,//本平台分类
                    brand: null,//品牌
                    parentsku: null,//SKU
                    productTitle:null,//标题
                    manufacturer:null,//制造商
                    c_checkList: [],
                    s_checkList: [],
                    description: null,
                    shotDescription: null,
                    mvURL: null,
                    detail:'',
                    startDate:null,
                    endDate: null,
                    isPack:'',
                    pics:[],
                    barcodeType:'UPC',//商品条形码类型
                    dealDays:null,//处理天数
                    transForm:null,//运输模版
                    bulletPoint:null,//亮点1
                    bulletPoint2:null,//亮点2
                    bulletPoint3:null,//亮点3
                    bulletPoint4:null,//亮点4
                    bulletPoint5:null,//亮点5
                    searchTerms:null,//关键词信息
                    platTypeVale:null, //别的平台值,以ID分割
                    UPC:null,
                    goodsState:null,
                },
                selectBzzt:null,
                bzzt:[{label:'ColorName',value:[{label:'Color',valArr:[],model:null,selectList:[]}]},{label:'ColorSize',value:[{label:'Color',valArr:[],model:null,selectList:[]},{label:'Size',valArr:[],model:null,selectList:[]}]}],//变种主题
                editorConfig:{
                    height:'300px',
                    toolbar:  toolbar = [
                        [ 'Source','Maximize'],
                        [ 'Bold', 'Italic', 'Underline', 'Strike'],
                        [ 'TextColor', 'BGColor' ],
                        [  'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock','-','NumberedList', 'BulletedList', '-', 'Outdent', 'Indent',  '-','Subscript', 'Superscript'],
                        [ 'HorizontalRule','RemoveFormat'],
                        ['NewPage', 'Preview', '-', 'Undo', 'Redo' ],
                        '/',
                        [ 'Styles', 'Format', 'Font', 'FontSize' ],
                        [ 'Paste', 'PasteText', 'PasteFromWord','Table'],
                        [ 'Link', 'Unlink','-' ,'Image']
                    ],
                    language: 'zh-cn',
                    wordcount:{
                        showCharCount: true,
                    }

                },
                urlSize: 0,
                isIndeterminate: true,
                checkAll: false,
                rules: {
                    shopAccount:[{required: true, message: '请填写店铺账号',  trigger: ['change']}],
                    aSite:[{required: true, message: '请选择站点', trigger: 'change'}],
                    catId:[{required: true, message: '请选择产品分类', trigger: 'change'}],
                    catIdType:[{required: true, message: '请选择产品类型', trigger: ['change']}],
                    sellForm:[{required: true, message: '请选择售卖形式', trigger: 'change'}],
                    brands:[{required: true, message: '请选择品牌入驻商', trigger: 'change'}],
                    parentsku: [{required: true, message: '请填写ParentSku', trigger: 'change'}],
                    productTitle: [{required: true, message: '请填写产品标题', trigger: 'change'}],
                    brand: [{required: true, message: '请填写品牌', trigger: 'change'}],
                    manufacturer: [{required: true, message: '请填写制造商', trigger: 'change'}],
                    platTypeName:[{required: true, message: '请选择产品分类', trigger: 'change'}],
                    classType:[{required: true, message: '请选择分类类型', trigger: ['change']}],
                    UPC:[{validator:checkUPC,required: true, trigger: ['change']}],
                    price:[{required: true, message: '请填写价格', trigger: 'change'}],
                    invent:[{required: true, message: '请填写产品数量', trigger: 'change'}],
                },
//                colorList: ['red', 'blue', 'yellow', 'black', 'purple', 'gray', 'white', 'syan', 'tan'],
                sizeList: ['L', 'M', 'S', 'XL', 'XXL', 'XXXL'],
                colorFilteField: null,
                sizeFilteField: null,
                otherColor: null,
                otherSize: null,
                treeSelect: {
                    value: 'id',
                    label: 'name',
                    children: 'children',
                },
                chooseType: false,//选择分类
                options2: [],
                platType:null,//类目值
                attrId:null,//类目的最后一级ID,用于查出所有的属性List
                cascaderName:null, //级联全路径名字
                sizePicList:[],
                uploadDis:true,
                checkList: [],
                showFileList: false,
                closeDelay: 0,
                tempImg: {},
                fileList: [],
                imgList:[],
                dataList:[],
                editorData:null,
                editorConfig:{
                    toolbar: [  ['Source','Maximize'],
                        ["Bold","Italic"],
                        ["NumberedList","BulletedList"]]
                },
                popoverRef:'popover-',
                popoverDisabled:false,
                attrList:[
                    {'label':'Manufacturer Part Number','proName':null,'isRequire':true},
                    {'label':'Outer Material Type','proName':null,'isRequire':true},
                    {'label':'Material Composition','proName':null,'isRequire':true},
                    {'label':'Color','proName':null,'isRequire':true},
                ],//属性信息列表
                imgCheckList:[],
                bzxxRules:{
                    skuno:[{ required: true, message: '请填写SKU', trigger: 'change' }],
                    uCode:[{ required: true, message: '请填写产品ID', trigger: 'change' }],
                    invent:[{ required: true, message: '请填写数量', trigger: 'change' }],
                    price:[{ required: true, message: '请填写价格', trigger: 'change' }]
                },
                bzxx:{
                    columnList:[],
                    tableData:[],
                    inventRadio:0, //修改库存radio的值
                    inventRadioDisabled_1:false,//显示直接修改库存
                    inventRadioDisabled_2:true,//禁止第二个选择
                    inventInput_1:null,
                    inventInput_2:null,
                },
                bzztAttr:[],//变种主题中的属性（单个主题）
                skuAttrGroup:[],//变种属性组合
                attrSelect:[],//主题中各属性集合 ，二维数组
                attrNameArr:[],//属性名称
                waitToEditSkuAttr:[],//待编辑的属性
                skuTimeOption : {disabledDate:(time)=> {return time.getTime() < Date.now()-1 * 24 * 3600 * 1000}},
                tabSkuEndTimeOption : {disabledDate:(time)=> {return time.getTime() < this.currentStartTime.getTime();}},
                updateSkuPriceVisible:false,
                updateSkuTimeVisible:false,
                updateSkuBarcodeVisible:false,//条形码更改弹框
                updateSkuNoteVisible:false,//修改sku注意事项弹框
                updateSkuColorMapVisible:false,
                barcodeModel:'1',
                autoBarcode:'',
                updateSkuBarcodeVal:null,
                updateSkuNoteTypeVal:'8',
                updateSkuNoteVal:null,
                updateSkuColorMapVal:null,
                currentStartTime:null,
                priceText:'价格',
                skuInventRadio:1,//1 直接修改库存量   2 根据现有库存量增减
                updateSkuInventNum_1:0 ,//库存量修改值
                updateSkuInventNum_2:0 ,//库存量修改值
                updateSkuPriceVal:null,//价格批量修改值
                updateSkuTimeVal:null,//促销时间批量修改值
                attrGroupArr:[],//属性名称和值组合  例如[{label:'Color',value:'red'}]
                updateSkuInventVisible:false,
                editor:null,

            }
        },
        computed: {
            dpList(){
                return this.$store.state.product.amazon.shopList;
            }
        },
        created() {
            var that = this;
            // this.getZdxz();
            this.loadEditData();
            // 获取本平台树
            loadDataMap().then((res) => {
                this.dataList=this.optionData(res.data);
            setTimeout(function () {
                that.$refs.childSelTree.initHandle();
            },100);
            })
        },
        methods: {
            //根基pid加载amazon数据
            loadEditData(){
                let that = this;
                getAmazonEdit(this.$route.query.pId).then((res) => {
                    var skuAndTableData = res.data.skuAndTableData;
                    var sellFormBean = res.data.skuAndTableData.sellFormBean;
                    let amazon = res.data.amazon;
                    let pics = res.data.pics;
                    that.firstForm.shopAccount=parseInt(amazon.shopId);//店铺账号
                    that.firstForm.aSite=amazon.aSite;//站点选择

                    if (amazon.classType != '' && amazon.classType != null){
                        that.firstForm.classType = parseInt(amazon.classType);//分类类型
                    }
                    if (amazon.catidType != '' && amazon.catidType != null){
                        that.firstForm.catIdType = parseInt(amazon.catidType);//产品类型
                    }
                    if (amazon.sellForm != '' && amazon.sellForm != null){
                        if (amazon.sellForm=='01'){
                            //处理小数
                            var toDecimal2 = toDecimal(sellFormBean.price);
                            var toDecimal3 = toDecimal(sellFormBean.promPrice);
                            if (toDecimal2){
                                this.firstForm.sellTableData.price=toDecimal2;
                            }
                            if (toDecimal3){
                                this.firstForm.sellTableData.promPrice=toDecimal3;
                            }
                            this.firstForm.sellTableData.startDate=sellFormBean.startDate;
                            this.firstForm.sellTableData.endDate=sellFormBean.endDate;
                            this.firstForm.sellTableData.invent=sellFormBean.invent;
                            this.firstForm.sellTableData.selectDate=sellFormBean.selectDate;
                            this.firstForm.UPC = sellFormBean.UPC;
                            //选择的是单品,但是有类目值,需要重新找一遍,不然点击多品种不会显示变种信息
                            if (amazon.catId != '' && amazon.catId != null){
                                that.firstForm.platTypeVale = amazon.catId;//产品分类（线上分类）
                                that.copyPlatTypeValue = that.firstForm.platTypeVale.split(",");
                                var list = this.firstForm.platTypeVale.split(",");
                                //获取类目最后一个id
                                var platTypeVale = list[list.length-1];
                                //分类类型集合
                                that.getClassTypeList(platTypeVale);
                                //获取类目的拼接名字
                                that.getSplictName();
                                //产品类型集合
                                that.getCatIdTypeList(platTypeVale);
                                //加载变种信息
                                that.getPlatAttrList();
                            }
                        }else{
                            //类目ID不为空
                            if (amazon.catId != '' && amazon.catId != null){
                                // that.firstForm.catId = amazon.catId;//产品分类（线上分类）
                                that.firstForm.platTypeVale = amazon.catId;//产品分类（线上分类）
                                that.copyPlatTypeValue = that.firstForm.platTypeVale.split(",");
                                var list = this.firstForm.platTypeVale.split(",");
                                //获取类目最后一个id
                                var platTypeVale = list[list.length-1];
                                //分类类型集合
                                that.getClassTypeList(platTypeVale);
                                //获取类目的拼接名字
                                that.getSplictName();
                                //产品类型集合
                                that.getCatIdTypeList(platTypeVale);
                                // that.getPlatProList();
                                that.platAttrSelectData = skuAndTableData.skuList;
                                that.bzxx.tableData = skuAndTableData.tableData;
                                //排序不为空
                                if (skuAndTableData.sort.length > 0){
                                    //根据ID按顺序添加
                                    for (var i=0; i<skuAndTableData.sort.length;i++){
                                        var sort = skuAndTableData.sort[i];
                                        for (var i_2=0; i_2<that.platAttrSelectData.length;i_2++){
                                            if (sort==that.platAttrSelectData[i_2].attrId){
                                                that.bzxx.columnList.push(that.platAttrSelectData[i_2]);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        that.firstForm.sellForm = amazon.sellForm;//售卖类型
                    }
                    if (amazon.typeNo != '' && amazon.typeNo != null){
                        that.firstForm.typeNo=parseInt(amazon.typeNo);//本平台分类
                    }
                    if (amazon.dataUrl != '' && amazon.dataUrl != null){
                        amazon.dataUrl.split(',').forEach(item => {   //来源url
                            let map ={'url':item}
                            this.firstForm.urls.push(map);
                        });
                    }
                    if(this.firstForm.urls.length == 0){
                        this.firstForm.urls.push({'url':''});
                    }
                    that.firstForm.parentsku=amazon.parentsku;
                    that.firstForm.productTitle=amazon.proTitle;
                    that.firstForm.brand=amazon.brand;
                    that.firstForm.manufacturer=amazon.manufacturer;
                    that.firstForm.detail=amazon.detail;
                    if (amazon.goodsState!=null && amazon.goodsState!=""){
                        that.firstForm.goodsState = amazon.goodsState;
                    }
//                价格运输
                    that.firstForm.dealDays=amazon.dealDays;
                    that.firstForm.transForm=amazon.transForm;
                    that.firstForm.isPack=amazon.isPack;
                    that.firstForm.pics = pics;
                    that.firstForm.bulletPoint = amazon.bulletPoint;
                    that.firstForm.bulletPoint2 = amazon.bulletPoint2;
                    that.firstForm.bulletPoint3 = amazon.bulletPoint3;
                    that.firstForm.bulletPoint4 = amazon.bulletPoint4;
                    that.firstForm.bulletPoint5 = amazon.bulletPoint5;
                    that.firstForm.searchTerms = amazon.searchTerms;
                    that.platProList = res.data.platProList;
                    //主图
                    if (amazon.mainPic != '' && amazon.mainPic != null){
                        that.firstForm.mainPic = amazon.mainPic;
                    }
                    //如果不设置为true,副文本第一次容器不会加载
                    that.ckVisible = true;
                })
            },
            imgOnload(item){
                const img = new Image();
                img.src = item.picUrl;
                item.width = img.width;
                item.height = img.height;
            },
            //选择分类
            getPlatTypeTree(){
                this.shopeeDialogVisible = true;
                if (this.firstForm.platTypeVale != null && this.firstForm.platTypeVale!=''){
                    this.bgHide();
                    this.copyPlatTypeValue = this.firstForm.platTypeVale.split(",");
                }else{
                    this.getPlatTypeList('04',0,'',0);
                }
            },
            //shopee平台类目选择确定按钮
            shopeeDialogSubmit(){
                //表格长度
                var length = this.platTypeList.length;
                //选择的值长度
                var length2 = this.copyPlatTypeValue.length;
                if (length != length2){
                    this.msgError("还有子级未选择,请补充");
                    return
                }
                var platTypeList = this.platTypeList[length2-1];
                let copyPlatTypeValue = this.copyPlatTypeValue[length2-1];
                for (var i=0; i<platTypeList.data.length; i++){
                    if (platTypeList.data[i].platId == copyPlatTypeValue && platTypeList.data[i].childrenTree.length > 0){
                        this.msgError("还有子级未选择,请补充");
                        return
                    }
                }
                let platTypeVale = this.firstForm.platTypeVale;
                let copyPlatTypeValue2 = this.copyPlatTypeValue.join(",");
                //不相等才执行操作
                if (platTypeVale != copyPlatTypeValue2){
                    //选择正确之后,赋值
                    this.firstForm.platTypeVale = copyPlatTypeValue2;
                    //清空表格
                    this.bzxx.tableData=[];
                    this.getPlatAttrList();
                    //确定之后要把值赋予input框
                    this.getPlatProList();
                    this.getSplictName();
                    //获取分类类型
                    this.getClassTypeList(copyPlatTypeValue);
                    //获取产品类型
                    this.getCatIdTypeList(copyPlatTypeValue);
                }
                this.shopeeDialogVisible = false;
            },
            editImg(index){
                // this.$message.warning("")
                alert("还未实现此功能");
            },
            removeImg(index) {
                let pic = this.firstForm.pics[index];
                let index_c = this.imgCheckList.indexOf(pic);
                if(index_c > -1){
                    this.imgCheckList.splice(index_c,1);
                }
                this.firstForm.pics.splice(index,1);
            },
            //选择图片
            selectPic(val,item){

            },
            //设为主图
            setMainPic(val){
                let count = this.imgCheckList.length;
                if(count >= 9){
                    this.$message.warning("当前已选择9张图片！");
                    return
                }else{
                    this.firstForm.pics.forEach((item,index) => {
                        item.isMain = '0';
                    });
                    let pic = JSON.parse(JSON.stringify(this.firstForm.pics[val]));
                    pic.isMain='1';
                    this.firstForm.pics.splice(val,1);
                    this.firstForm.pics.unshift(pic);
                    this.imgCheckList.unshift(pic);
                    let picUrl = JSON.parse(JSON.stringify(pic.picUrl));
                    this.firstForm.mainPic=picUrl;
                }
                    // if(count < 9){
                    //     this.firstForm.pics.forEach((item,index) => {
                    //         if(val == index){
                    //             item.isMain = '1';
                    //             if(this.imgCheckList.indexOf(item) < 0){
                    //                 this.imgCheckList.push(item);
                    //             }
                    //         }else{
                    //             item.isMain = '0';
                    //         }
                    //     });
                    // }else{
                    //     let currentImg = this.firstForm.pics[val];
                    //     console.log(currentImg);
                    //     if(this.imgCheckList.indexOf(currentImg) > -1){
                    //         this.firstForm.pics.forEach((item,index) => {
                    //             if(val == index){
                    //                 item.isMain = true;
                    //             }else{
                    //                 item.isMain = false;
                    //             }
                    //         });
                    //     }else{
                    //         this.$message.warning("当前已选择9张图片！")
                    //     }
                    // }


            },
            imgInfoUpload(data){
                var that = this;
                let formData = new FormData();
                formData.append("imageFile", data.file);
                uploadImg(formData).then(res => {
                    if(res.code == 200){
                        let popoverDisabled = this.popoverDisabled;
                        that.msgSuccess("图片上传成功");
                        this.firstForm.pics.push({
                            'picUrl':res.data.img,
                            'width':res.data.width,
                            'height':res.data.height,
                            'isMain':"0",
                            'swatchImage':"0",
                            'isCheck':false,
                            'sort':null,
                            'isNetWord':"0",//代表不是网络图片
                        });
                        console.log(this.firstForm.pics);
                    }
                }).catch(err => {});
            },

            //
            attrMainImgUpload(data,fileList,isMain,swatchImage){
                var that = this;
                let formData = new FormData();
                formData.append("imageFile", data.file);
                var pId = this.$route.query.pId;
                uploadImg(formData).then(res => {
                    if(res.code == 200){
                        that.msgSuccess("图片上传成功");
                        fileList.push({
                            'picUrl':res.data.img,
                            'width':res.data.width,
                            'height':res.data.height,
                            'isMain':isMain,
                            'swatchImage':swatchImage,
                            'pId':pId,
                        });
                    }
                }).catch(err => {});
            },

            //移除sku图片
            removeSkuImg(list,index){
                list.splice(index,1);
            },

            skuImgBeforeUpload(file){

            },
            skuImgExceed(file,fileList){
                this.$message.warning(`附图最多只能上传 `+fileList.length+ ` 张。`);
            },

            beforeUpload(file) {
            },
            //变种主题下拉框change事件
            bzztChange(val){
                var params = {
                    attrId:val,
                }
                //获取属性值
                getBzztValListByAttrId(params).then(res => {
                    this.bzztAttr = res.data
                }).catch(err => {});
            },
            //变种属性添加
            addSkuArr(attr,inputName){
                //判断是否有重复
                var checkList = attr.checkList;
                for (var i=0 ; i<checkList.length; i++){
                    if (checkList[i]==inputName){
                        return
                    }
                }
                //1.先在集合里面添加一个子对象
                var val = {
                    name:inputName,
                    backupName:inputName,
                    id:null,
                    isEdit:false,
                    checked:true,
                }
                attr.attrValList.push(val);

                //2.然后在checkedList添加值为已选中
                attr.checkList.push(inputName);
                //3.调用方法
                this.attrValChecked(true,val,attr);
                attr.inputValue=null;
            },
            //对添加的属性进行编辑
            editCheckBox(item){
                let c = this.waitToEditSkuAttr.filter(attr => {return item.code == attr.code});
                if(c.length == 0){
                    this.waitToEditSkuAttr.push(JSON.parse(JSON.stringify(item)));
                }
                item.isEdit = true;
            },
            //保存属性编辑
            saveEditItem(attrVal,attr){
                this.updateAttrValName(attr,attrVal);
                attrVal.name = attrVal.backupName;
                attrVal.isEdit = false;
                attr.checkList;
            },
            //取消属性编辑
            cancleEditItem(item){
                let old = this.waitToEditSkuAttr.filter(attr => {return item.code == attr.code});
                item.name = old[0].name;
                console.log(item);
                item.isEdit = false;
            },
            optionData(data) {
                let cloneData = JSON.parse(JSON.stringify(data))      // 对源数据深度克隆
                return cloneData.filter(father => {                      // 循环所有项，并添加children属性
                    let branchArr = cloneData.filter(child => father.id == child.parentId);       // 返回每一项的子级数组
                branchArr.length > 0 ? father.children = branchArr : ''   //给父级添加一个children属性，并赋值
                return father.parentId == 0;      //返回第一层
            });
            },
            //获取本平台树的ID
            getTreeNodeId(val){
                this.firstForm.typeNo=val;
            },
            addUrl: function () {
                let cope = {url:''};
                this.firstForm.urls.push(cope);
                let urls = this.firstForm.urls;
            },
            goUrl: function (val) {
                window.open(val, '_blank').location;
            },
            deleteUrl: function (val) {
                this.firstForm.urls.splice(val, 1);
                this.urlSize = this.firstForm.urls.length;
            },

            getZdxz: function() {
                this.loading = true;
                loadZdxz().then((res) => {
                    this.dpzdxzList = res.rows;
                this.loading = false;
                })
            },
            //锚点
            sideBarTool: function () {
                var aNav = $('#LoutiNav li');
                var aDiv = $('#main .t_plane');
                $(window).scroll(function () {
                    var winH = $(window).height();//可视窗口高度
                    var iTop = $(window).scrollTop();//鼠标滚动的距离
                    aDiv.each(function () {
                        if (winH + iTop - $(this).offset().top > winH - 200) {
                            aNav.removeClass('active');
                            aNav.eq($(this).index()).addClass('active');
                        }
                    })
                });
                //点击回到对应面板
                aNav.click(function () {
                    var t = aDiv.eq($(this).index()).offset().top - 199;
                    $('body,html').animate({"scrollTop": t}, 500);
                    $(this).addClass('active').siblings().removeClass('active');
                });
            },
            //颜色过滤字段改变
            c_fieldChange: function (val) {
                $("#col_List .el-checkbox").each(function () {
                    if ($(this).find(".el-checkbox__label").text().indexOf(val) != -1) {
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                });
            },
            //尺寸字段过滤
            s_fieldChange: function (val) {
                $("#siz_List .el-checkbox").each(function () {
                    if ($(this).find(".el-checkbox__label").text().indexOf(val) != -1) {
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                });
            },
            beforeUpload(file) {
                let that = this;
                new Promise(function (resolve, reject) {
                    let _URL = window.URL || window.webkitURL;
                    let img = new Image();
                    img.onload = function () {
                        that.tempImg.width = img.width;
                        that.tempImg.height = img.height;
                        that.tempImg.url = _URL.createObjectURL(file);
                    }
                    img.src = _URL.createObjectURL(file);
                }).then(() => {return file;}, () => {
                    return Promise.reject();
                });
            },
            //一键生成sku
            creatSkuName(){
                if(this.firstForm.parentsku == null || this.firstForm.parentsku == ''){
                    this.$message.warning("ParentSKU为空，无法使用一键生成！");
                    return false;
                }
                this.bzxx.tableData.forEach(row =>{
                    row['skuno'] = this.firstForm.parentsku+"-#"+randomWord(true,7,10);
                    // this.attrNameArr.forEach(attr => {
                    //     row['skuno'] +=  '-' + row[attr];
                    // })
                })
                console.log(this.bzxx.tableData);
            },
            //一键修改条形码
            updateSkuBarcode(){
                let numArr = this.updateSkuBarcodeVal.split("\n");
                this.bzxx.tableData.forEach((row,index) => {
                    if(index <= numArr.length){
                        row.uCode = numArr[index];
                    }
                })
                this.updateSkuBarcodeVal = null;
                this.updateSkuBarcodeVisible = false;
            },
            updateSkuColorMap(){
                this.bzxx.tableData.forEach((row,index) => {
                    row.colorMap = this.updateSkuColorMapVal;
                })
                this.updateSkuColorMapVal = null;
                this.updateSkuColorMapVisible = false;
            },
            //批量修改注意事项
            updateSkuNote(){
                this.bzxx.tableData.forEach(row => {
                    row.condition1 = this.updateSkuNoteTypeVal;
                    row.note = this.updateSkuNoteVal;
                });
                this.updateSkuNoteTypeVal = '8';
                this.updateSkuNoteVal = null;
                this.updateSkuNoteVisible = false;
            },
            //批量修改库存
            updateSkuInvent(){
                if(this.skuInventRadio == 1){
                    this.bzxx.tableData.forEach(row =>{
                        row.invent = this.updateSkuInventNum_1;
                    });
                }else if(this.skuInventRadio == 2){
                    this.bzxx.tableData.forEach(row =>{
                        row.invent = parseInt(row.invent) + parseInt(this.updateSkuInventNum_2)
                    });
                }
                this.updateSkuInventVisible = false;
            },
            openPriceDialog(val){
                this.priceText = val;
                this.updateSkuPriceVisible = true;
            },
            updateSkuPrice(){
                console.log(this.updateSkuPriceVal);
                if(this.priceText == '价格'){
                    this.bzxx.tableData.forEach(row =>{
                        row.price = this.updateSkuPriceVal;
                    });
                }else if(this.priceText == '促销价'){
                    this.bzxx.tableData.forEach(row =>{
                        row.promPrice = this.updateSkuPriceVal;
                    });
                }
                this.updateSkuPriceVal = null;
                this.priceText = null;
                this.updateSkuPriceVisible = false;
            },
            //一键修改促销时间
            updateSkuPromTime(){
                if(this.updateSkuTimeVal == null){
                    return false;
                }
                this.bzxx.tableData.forEach(row =>{
                    row.startDate = this.updateSkuTimeVal[0];
                    row.endDate = this.updateSkuTimeVal[1];
                });
                this.updateSkuTimeVal = null;
                this.updateSkuTimeVisible = false;
            },
            setCurrentSku(startTime){
                this.currentStartTime = startTime;
            },
            moveAttr(row, index) {
                this.bzxx.tableData.splice(index,1);
                //1.获取动态列的全部索引
                for (var i=this.bzxx.columnList.length-1; i>=0; i--){
                    var column = "column_"+i;
                    var valName = row[column];
                    var flag = false;
                    for (var i_2=0; i_2<this.bzxx.tableData.length; i_2++){
                        var valName_2 = this.bzxx.tableData[i_2][column];
                        if (valName_2==valName){
                            flag = true;
                            break;
                        }
                    }
                    //标记没改变,删除checked的对应值,把 √ 去掉
                    if (!flag){
                        var checkList = this.bzxx.columnList[i].checkList;
                        let attrValList = this.bzxx.columnList[i].attrValList;
                        //删除checked选中的值
                        for (var i_3=0; i_3<checkList.length; i_3++){
                            if (checkList[i_3] == valName){
                                checkList.splice(i_3,1);
                            }
                        }
                        //把checked设置为false
                        for (var i_3=0; i_3<attrValList.length; i_3++){
                            if (attrValList[i_3].name == valName){
                                attrValList[i_3].checked =false;
                            }
                        }
                        //整个删除
                        if (checkList.length <= 0){
                            this.bzxx.columnList.splice(i,1);
                        }
                    }

                }
            },
            //导出全部图片
            downloadAllPic(){
                let urls = [];
                this.firstForm.pics.forEach(pic =>{
                    urls.push(pic.picUrl);
                });
                let param = urls.join(',');
                downLoadZipP("/product/amazon/batchDownloadPic",param);

            },

            //清空全部图片
            cleanAllPic(){
                this.firstForm.pics = [];
            },
            //点击类目触发
            platTypeTest(item,item_2,index){
                item.bgHide = item_2.platId;
                this.getPlatTypeList('04',item_2.platId,'',index+1);
            },
            //别的平台产品回显
            bgHide(){
                let platTypeVale = this.firstForm.platTypeVale;
                var params = {
                    platTypeVale:platTypeVale
                };
                treeView(params).then(res => {
                    this.platTypeList=res.data
                }).catch(err => {});
            },
            getPlatTypeList(type,id,platName,index){
                var params  ={
                    platNo:type,
                    pPlatId:id,
                    platName:platName,
                }
                getPlatTypeList(params).then(res => {
                    //如果有值,则只替换data
                    if (platName != '' && platName != null){
                        if(res.data != null && res.data!=undefined){
                            this.$set(this.platTypeList[index],'data' , res.data.data);
                        }else{
                            this.$set(this.platTypeList[index],'data' , []);
                        }
                    }else{
                        //没有值则替换整个
                        for (var i=0; i<this.platTypeList.length; i++){
                            if (i>=index){
                                this.platTypeList.splice(i,1)
                            }
                        }
                        if(res.data != null && res.data!=undefined){
                            this.$set(this.platTypeList, index, res.data);
                        }
                    }
                    //赋值类目ID
                    this.copyPlatTypeValue =  this.getPlatTypeIds();
                }).catch(err => {});
            },
            //搜索别的平台值
            searchPlatTypeList(pId,value,index){
                this.getPlatTypeList('04',pId,value,index);
            },
            //遍历类目集合,取出ID
            getPlatTypeIds(){
                var platIds =[];
                let platTypeList = this.platTypeList;
                for (var i=0; i<this.platTypeList.length; i++){
                    let bgHide2 = this.platTypeList[i].bgHide;
                    if(bgHide2 == null || bgHide2 == ''){
                        break;
                    }
                    platIds.push(this.platTypeList[i].bgHide);
                }
                return platIds;
            },
            //如果类目有值则回显
            getPlatProList(){
                var list = this.firstForm.platTypeVale.split(",");
                var platTypeVale = list[list.length-1];
                if (platTypeVale != null && platTypeVale != ""){
                    var params = {
                        catId:platTypeVale,
                    }
                    getList(params).then(res => {
                        for (var i=0; i<res.data.length; i++){
                            var dataType = res.data[i].dataType;
                            switch(dataType) {
                                case '03':
                                    res.data[i].selectValue=[];
                                    break;
                                case '06':
                                    res.data[i].selectValue=[];
                                    break;
                                default:
                                    res.data[i].selectValue="";
                            }
                        }
                        this.platProList = res.data;
                    }).catch(err => {});
                }
            },
            //枚举多选
            checkedManyVal(value) {
                let platProList = this.platProList;
            },
            //根据ids获取拼接的名字
            getSplictName(){
                var ids = this.copyPlatTypeValue;
                getSplictName(ids).then(res => {
                   this.firstForm.platTypeName=res.data;
                }).catch(err => {});
            },
            //通过类目ID查询变种属性父级集合
            getPlatAttrList(){
                var list = this.firstForm.platTypeVale.split(",");
                var platTypeVale = list[list.length-1];
                var params = {
                    catId:platTypeVale
                }
                getBzztAttrListByCatId(params).then(res => {
                    this.platAttrSelectData = res.data
                }).catch(err => {});
            },
            //点击属性值
            attrValChecked(checked,attrVal,attr){
                //获取索引删除
                var dynamicColumn2 = this.dynamicColumn(attr.attrId);
                var valName = attrVal.name;
                if (attr.checkList.length <= 0){
                    this.bzxx.columnList.splice(dynamicColumn2,1)
                    let platAttrSelectData = this.platAttrSelectData;
                    this.false_deleteTableData(dynamicColumn2,attrVal,attr);
                    return
                }
                //小于0才添加
                if (dynamicColumn2 < 0){
                    if (this.bzxx.columnList.length == 1){
                        this.bzxx.tableData=[];
                    }
                    this.bzxx.columnList.push(attr)
                }
                //为true则添加生成表格数据
                if (checked){
                    attrVal.checked=true;
                    this.true_InsertTableData(attr,attrVal)
                }else{
                    attrVal.checked=false;
                    //为false删除表格数据
                    this.false_deleteTableData(dynamicColumn2,attrVal,attr);
                }
            },
            //为false删除数据
            false_deleteTableData(index,attrVal,attr){
                var valName = attrVal.name;
                //使用逆向循环删除数据
                for (var i=this.bzxx.tableData.length-1; i>=0; i--){
                    var column = 'column_'+index;
                    let newVar = this.bzxx.tableData[i][column];
                    if (newVar == valName){
                        this.bzxx.tableData.splice(i,1);
                    }
                }
                //删除数据时,存在还有选中的,则需要再生成表格数据,如果不处理,会出现有选中,没数据
                if (this.bzxx.columnList.length >= 1 && this.bzxx.tableData.length==0){
                    this.true_InsertTableData(attr,valName)
                }
            },
            //为true时生成数据
            true_InsertTableData(attr,attrVal){
                var valName = attrVal.name;
                var list=[];
                for (var i=0; i<this.bzxx.columnList.length; i++){
                    if (this.bzxx.columnList[i].attrId == attr.attrId){
                        list.push([valName]);
                    }else{
                        list.push(this.bzxx.columnList[i].checkList);
                    }
                }
                var cartesianProduct = calcDescartes(list);
                // var attrId = attr.attrId;
                // var id = attrVal.id;
                //遍历
                for (var i=0; i<cartesianProduct.length; i++){
                    var table = {
                        skuno:null,
                        uCode:null,
                        colorMap:null,
                        condition1:'8',
                        note:null,
                        price:null,
                        promPrice:null,
                        startDate:null,
                        endDate:null,
                        invent:null,
                        mainFile:[],
                        swatchFile:[],
                        otherFile:[],
                    }
                    var pro="";
                    var newValList = cartesianProduct[i];
                    if (newValList.constructor==Array){
                        for (var i_2=0; i_2<newValList.length; i_2++){
                            table['column_'+i_2] = newValList[i_2];
                        }
                    }else{
                        table['column_0']=cartesianProduct[i];
                    }
                    this.bzxx.tableData.push(table);
                }
            },
            //修改属性值的名字
            updateAttrValName(attr,attrVal){
                var backupName = attrVal.backupName;
                var name = attrVal.name;
                var index = this.dynamicColumn(attr.attrId);
                for (var i=0; i<this.bzxx.tableData.length; i++){
                    var column = 'column_'+index;
                    var oldName = this.bzxx.tableData[i][column];
                    if (oldName == name){
                        this.$set(this.bzxx.tableData[i],column,backupName);
                    }
                }
                this.updateAttrValCheckName(attr,name,backupName);
            },
            //修改属性值时,需要把原本选中的属性值修改掉,不然会默认不选中
            updateAttrValCheckName(attr,name,backupName){
                var checkList = attr.checkList;
                for (var i=0; i<checkList.length; i++){
                    if (checkList[i] == name){
                        checkList[i]=backupName;
                    }
                }
            },
            //动态列
            dynamicColumn(attrId){
                for (var i=0; i<this.bzxx.columnList.length; i++){
                    if (this.bzxx.columnList[i].attrId == attrId){
                        return i;
                    }
                }
                return -1;
            },
            //获取分类类型集合
            getClassTypeList(catId){
                var params = {
                    catId:catId,
                    type:0, //代表分类类型
                }
                getClassList(params).then(res => {
                    this.classTypeList = res.data
                }).catch(err => {});
            },
            //获取产品类型集合
            getCatIdTypeList(catId){
                var params = {
                    catId:catId,
                    type:1,//代表产品类型
                }
                getClassList(params).then(res => {
                    this.catIdTypeList = res.data
                }).catch(err => {});
            },
            save(){
                this.$refs.firstForm.validate((valid) => {
                    if (valid) {
                        let bzxx = this.$refs.bzxx;
                        this.$refs.bzxx.validate((valid_2) => {
                            if (valid_2){
                                var firstForm = this.firstForm;
                                firstForm.platProList = this.platProList;
                                firstForm.platAttrSelectData = this.platAttrSelectData;
                                firstForm.bzxxTable=this.bzxx.tableData;
                                firstForm.columnList=this.bzxx.columnList;
                                firstForm.pId=this.$route.query.pId;
                                saveAmazonEditMsg(firstForm).then(res => {
                                    this.msgSuccess(res.msg)
                                }).catch(err => {});
                            }else{
                                this.msgError("请补充必填信息");
                                return;
                            }
                        });

                    } else {
                        this.msgError("请补充必填信息");
                        return;
                    }
                });
            },
            release(){
                var firstForm = this.firstForm;
                var sellForm = firstForm.sellForm;
                firstForm.platProList = this.platProList;
                firstForm.platAttrSelectData = this.platAttrSelectData;
                firstForm.bzxxTable=this.bzxx.tableData;
                firstForm.columnList=this.bzxx.columnList;
                firstForm.pId=this.$route.query.pId;
                firstForm.goodsState = this.editor.getData();
                this.$refs.firstForm.validate((valid,msgArr) => {
                    if (valid) {
                        let bzxx = this.$refs.bzxx;
                        if (this.firstForm.pics.length <=0){
                            this.$message.error("图片至少要上传一张");
                            return
                        }else{
                            var isMainFlag = false;
                            for (var i=0; i<this.firstForm.pics.length;i++){
                                if (this.firstForm.pics[i].isMain==1){
                                    isMainFlag = true;
                                }
                            }
                            if(!isMainFlag){
                                this.$message.error("主图不能为空,请设置主图");
                                return
                            }
                        }
                        //因为使用了v-if,所以不能直接使用验证,否则会报方法不存在
                        if(sellForm=='02'){
                            this.$refs.bzxx.validate((valid_2,msgArr2) => {
                                if (this.bzxx.tableData.length<=0){
                                    this.$message.error("多变体至少要填写一个");
                                    return
                                }
                                if (valid_2){
                                    var tableData = this.bzxx.tableData;
                                    for (var i=0; i<tableData.length;i++){
                                        let mainFile = tableData[i].mainFile;
                                        if(mainFile.length <=0){
                                            this.$message.error("变种主图不能为空");
                                            return
                                        }
                                    }
                                    releaseProduct(firstForm).then(res => {
                                        if(res.code == 200){
                                            this.msgSuccess(res.msg);
                                            this.$router.push({path:'/product/amazon/onLine'})
                                        }
                                    }).catch(err => {});
                                }else{
                                    let arr = [];
                                    for(let item in msgArr2){
                                        msgArr2[item].forEach(obj =>{
                                            if(arr.indexOf(obj.message)<0){
                                                arr.push(obj.message);
                                            }
                                        })
                                    }
                                    this.$message.error({
                                        dangerouslyUseHTMLString: true,
                                        showClose: true,
                                        message: '<span>'+arr.join('，')+'</span>'
                                    });
                                }
                            });
                        }else{
                            releaseProduct(firstForm).then(res => {
                                if(res.code == 200){
                                    this.msgSuccess(res.msg);
                                    this.$router.push({path:'/product/amazon/onLine'})
                                }
                            }).catch(err => {});
                        }
                    } else {
                        let arr = [];
                        for(let item in msgArr){
                            msgArr[item].forEach(obj =>{
                                if(arr.indexOf(obj.message)<0){
                                    arr.push(obj.message);
                                }
                            })
                        }
                        this.$message.error({
                            dangerouslyUseHTMLString: true,
                            showClose: true,
                            message: '<span>'+arr.join('，')+'</span>'
                        });
                    }
                });
            },
            //处理单品促销时间
            promDate(e){
                let selectDate = this.firstForm.sellTableData.selectDate;
                if (e==null || selectDate.length <= 0){
                    this.firstForm.sellTableData.startDate = null;
                    this.firstForm.sellTableData.endDate = null;
                }else{
                    this.firstForm.sellTableData.startDate = e[0];
                    this.firstForm.sellTableData.endDate = e[1];
                }
            },
            //处理整数
            handleNumber(name){
                let match = this.firstForm.sellTableData[name].replace(/[^\d]/g, '').replace(/^0{1,}/g,'');
                this.firstForm.sellTableData[name] = match
            },
            //处理小数
            handleDecimal(name){
                let match = this.firstForm.sellTableData[name].replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g);
                if (match.length >0){
                    this.firstForm.sellTableData[name]=match[0]
                }
            },
            //点击售卖形式
            sellFormClick(e){
                if (e=='02'){
                    if (this.copyPlatTypeValue.length == 0){
                        this.firstForm.sellForm='01';
                        this.msgError("请先选择产品分类,再设置多变种");
                    }
                }
            },
            //选择修改库存的方式,禁止输入不被选择的那个
            inventRadioChange(e){
                if (e==0){
                    this.bzxx.inventRadioDisabled_1=false
                    this.bzxx.inventRadioDisabled_2=true
                    this.$nextTick(() => {
                        this.$refs.inventInput_1.focus();
                    })
                }else{
                    this.bzxx.inventRadioDisabled_1=true
                    this.bzxx.inventRadioDisabled_2=false
                }
            },
            //取消修改库存弹出框
            cancelInvent(){
                this.updateSkuInventVisible=false;
                this.cancelPrice();
            },
            //提交库存量的更改
            sumbitInvent(){
                var inventRadio = this.bzxx.inventRadio;
                var tableData = this.bzxx.tableData;
                var intValue=0
                if (inventRadio==0){
                    var inventInput1 = this.bzxx.inventInput_1;
                    if(inventInput1!=null){
                        intValue =parseInt(inventInput1);
                        for (var i=0;i < tableData.length;i++) {
                            tableData[i].invent=intValue+"";
                        }
                    }
                }else {
                    var inventInput2 = this.bzxx.inventInput_2;
                    if(inventInput2!=null){
                        intValue =parseInt(inventInput2);
                        for (var i=0;i < tableData.length;i++) {
                            var invent =null;
                            if (tableData[i].invent!=""){
                                invent =parseInt(tableData[i].invent)
                            }
                            if (invent!=null){
                                //最终的值
                                var value;
                                //小于0,则是负数,则减掉
                                if (intValue<0){
                                    value=invent+intValue;
                                    if (value < 0){
                                        value=0;
                                    }
                                }else{
                                    //不是负数则是增加
                                    value = invent+intValue;
                                }
                                tableData[i].invent=value+"";
                            }else{
                                tableData[i].invent=intValue+"";

                            }
                        }
                    }

                }
                this.updateSkuInventVisible=false;
                this.cancelPrice();
            },
            cancelPrice(){
                this.bzxx.inventInput_1=null;
                this.bzxx.inventInput_2=null;
            },
            //编辑器器
            getEditor(editor){
                this.editor  = editor;
            },
            appBzxxPic(group){
                var mainFile = group.mainFile;
                var otherFile = group.otherFile;
                var swatchFile = group.swatchFile;
                var tableData = this.bzxx.tableData;
                for (var i=0; i<tableData.length;i++){
                    if (mainFile.length >0){
                        tableData[i].mainFile = mainFile
                    }
                    if (otherFile.length >0){
                        tableData[i].otherFile = otherFile
                    }
                    if (swatchFile.length >0){
                        tableData[i].swatchFile = swatchFile
                    }
                }
            },
            handleUPCValue(value){
                let new_value = value.replace(/[^\d]/g, '');
                this.firstForm.UPC = new_value;
            },
            handleUCodeValue(value,index){
                let new_value = value.replace(/[^\d]/g, '');
                this.bzxx.tableData[index].uCode = new_value;
            }
        },
        mounted() {
            this.sideBarTool();
        }
    }
</script>

<style scoped>
    #url_ly .el-input-group__append, #url_ly .el-input-group__prepend {
        padding: 0 10px !important;
        color: #000000;
    }

    #url_ly .el-input-group__append:hover {
        color: #409eff;
    }

    .url_a {
        color: #409eff;
        cursor: pointer;
        font-size: 18px;
    }

    i {
        font-style: normal;
    }

    ul, li, dl, ol {
        list-style: none;
    }

    #LoutiNav {
        position: fixed;
        top: 150px;
        right: 50px;
        display: none;
    }

    #LoutiNav li {
        width: 80px;
        height: 30px;
        line-height: 30px;
        text-align: left;
        cursor: pointer;
        position: relative;
    }

    #LoutiNav li svg{
        position: absolute;
        left: -23px;
        top: 7px;
        display: none;
    }

    #LoutiNav .active {
        color: red;
    }

    #LoutiNav .active svg{
        display: block;
    }

    #goTop {
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: gray;
        position: fixed;
        bottom: 30px;
        right: 30px;
        cursor: pointer;
        border-radius: 5px;
        display: none;
    }


    #erweima {
        width: 130px;
        height: 130px;
        background: palegreen;
        display: none;
        position: absolute;
        right: 46px;
        bottom: 5px;
        line-height: 130px;
        text-align: center;
        font-size: 20px;
        border-radius: 10px;
    }


    .self_el_item_form .el-form-item__content, .self_el_item_form .el-form-item__label {
        line-height: 30px !important;
    }

    .self_el_item_form .el-form-item {
        margin-bottom: 17px !important;
    }

    .item_bot {
        display: flex;
    }

    .item_bot span, .item_bot > .el-checkbox__label {
        font-size: 12px !important;
    }

    #proInfo .el-collapse-item__header {
        height: 32px !important;
        border: 0px solid #EBEEF5 !important;
        border-radius: 5px;
    }

    .el-collapse-item:last-child {
        border: 1px solid #ccc;
        border-radius: 5px;
    }

    #col_List, #siz_List {
        /* height: 150px; */
        overflow: auto;
    }

    #col_List .el-checkbox {
        width: 50px;
    }

    .span_4 {
        float: right;
    }

    .radio-group-two .el-radio {
        width: 50px
    }

    .image {
        width: 250px;
        height: 200px;
        display: block;
    }
    .cursor >>> .el-icon-error:before{
        cursor: pointer;
    }

    .form-item-props {
        padding-left: 150px;
        width: 50%;
        padding-bottom: 10px
    }

    .form-item-props .el-form-item__label {
        width: 200px !important;
    }

    .form-item-props .el-form-item__content {
        margin-left: 200px !important;
        display: flex
    }

    .mini-btn {
        padding: 2px 0 !important;
    }

    #col_List,#siz_List{
        /* height: 150px; */
        overflow: auto;
    }
    #col_List .el-checkbox{
        width: 120px;
    }
    #siz_List .el-checkbox{
        width: 120px;
    }

    #url_ly .el-input-group__append:hover {
        color: #409eff;
    }

    .url_a {
        color: #409eff;
        cursor: pointer;
        font-size: 18px;
    }
     .use-width{width: calc(100% - 6px) !important;height: initial !important;}
     .use-height{width: initial !important;height: calc(100% - 6px) !important;}
     .bzsx_list{margin-top: 10px}
    .bzsx_title{display: flex;height: 40px;background-color: #f2f2f2;border-bottom: 1px solid #e8e8e8;padding: 0 10px;align-items: center}
    .platType_1{
        height: 250px;
        border:1px solid #EBEEF5;
        width: 200px;
        margin: 6px 6px 0px 6px;
        padding: 6px;
        float: left!important;
    }
    .platType_2{
        height: 250px;
        width: 200px;
        overflow: auto;
    }
    .rowbg:hover{
        background-color: #eee;
    }
    .bg{
        background-color: #eee;
    }
    .ch{
        text-align: right;
    }
    .ch >>>.el-icon-arrow-right:before{

        font-weight:bolder;
        color: black;
    }
    .platRow{
        width: 100%;
        display: flex;
        white-space: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
    }
    .attrVal{
        border:1px solid #EBEEF5;
        padding: 5px;
        border-radius: 4px;
    }
</style>
